<template>
    <div class="bg-white px-md-5 py-3">
        <h3 class="step-title">{{ isEditing ? 'Fidelización y retención de talento' : 'Creación de curso' }}</h3>
        <small>{{ isEditing ? 'Edita el contenido del curso...' : 'Crea el contenido ideal para tus colaboradores' }}</small>

        <div :class="{ row: isEditing }">
            <div :class="{ 'col-md-6': isEditing }">
                <div class="preview-container rounded-8 my-5">
                    <div class="row">
                        <div class="col-md-6 mx-auto">
                            <div class="card p-0 rounded-8 preview-card">
                                <div class="card-header bg-gray p-0">
                                    <img src="" ref="previewStepImage" v-if="step1Data.cover" alt="" class="card-img-top">
                                    <div v-if="!step1Data.cover" class="d-flex justify-content-center preview-img-container align-items-center py-5">
                                        <i class="fa fa-image fa-3x"></i>
                                    </div>
                                </div>
                                <div class="card-body preview-card-body">
                                    <span class="badge badge-secondary">Curso</span>
                                    <h5 class="card-title">{{ step1Data.name || 'Título del curso' }}</h5>
                                    <p class="card-text">{{ step1Data.description || 'Breve descripción del curso' }}</p>
                                </div>
                            </div>
                        </div>
                        <p class="text-center">Previsualización de la tarjeta del curso</p>
                    </div>
                </div>
            </div>
            <div :class="{ 'col-md-6': isEditing }">
                <div class="row mt-4">
                    <div class="form-group">
                        <label for="course-name"><strong>Nombre del curso</strong></label>
                        <input type="text" v-model="step1Data.name" class="form-control rounded-8 sin-borde"
                            placeholder="Nombre del curso" aria-label="Nombre del curso" id="course-name"/>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="form-group">
                        <label for="course-description"><strong>Descripción</strong></label>
                        <textarea class="form-control rounded-8 sin-borde" v-model="step1Data.description" id="course-description" :rows="rows" placeholder="Descripción del curso"></textarea>
                    </div>
                </div>

                <div class="row mt-4">
                    <span><strong>Portada del curso</strong></span>
                    <p>Seleccione una imagen portada para el curso.</p>
                    <input ref="coverUploader" class="d-none" type="file" @change="onCoverChanged" id="">
                    <v-btn class="bg-outline-utel" rounded outlined :loading="isSelecting" @click="handleCoverSelect">
                        Seleccionar archivo
                    </v-btn>
                </div>

                <div class="row mt-4 mb-3">
                    <label for="courseLevelSelect"><strong>Nivel del curso</strong></label>
                    <select v-model="step1Data.level" class="form-control rounded-8 sin-borde" id="courseLevelSelect">
                        <option value="principiante">Principiante</option>
                        <option value="intermedio">Intermedio</option>
                        <option value="experto">Experto</option>
                    </select>
                </div>

                <div class="row mt-4" v-if="isEditing">
                    <label class="label-lesson" for="">Duración del curso</label>
                    <div class="d-flex p-0">
                        <div class="col-md-4 ps-0">
                            <input type="number" v-model="step1Data.cantidad_duracion_del_curso" class="form-control sin-borde rounded-8" placeholder="Duración">
                        </div>
                        <div class="col-md-8 pe-0">
                            <select v-model="step1Data.tipo_duracion_del_curso" class="form-control sin-borde rounded-8">
                                <option value="minutos" selected>Minuto(s)</option>
                                <option value="horas">Hora(s)</option>
                                <option value="dias">Día(s)</option>
                                <option value="semanas">Semana(s)</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="!isEditing" class="d-flex mt-5 justify-content-end">
            <button class="btn bg-outline-utel text-primary rounded-8 px-5 py-2" @click="onCancel">
                Cancelar
            </button>
            <button :disabled="!isValid" class="btn custombutton bg-utel text-white rounded-8 px-5 py-2 ms-3" @click="onNextStep">
                Continuar
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['stepData', 'editing'],
        data(){
            return {
                rows: 5,
                isSelecting: false,
                step1Data: this.stepData || {
                    name: '',
                    description: '',
                    cover: null,
                    level: 'intermedio'
                },
                isEditing: this.editing || false
            }
        },
        mounted(){
            if (this.step1Data.cover) {
                this.generatePreview();
            }
        },
        computed: {
            isValid(){
                return this.step1Data.name.trim().length > 0
                    && this.step1Data.description.trim().length > 0
                    && this.step1Data.level.trim().length > 0;
            }
        },
        methods: {
            handleCoverSelect(){
                this.isSelecting = true;

                window.addEventListener('focus', () => {
                    this.isSelecting = false
                }, { once: true });


                this.$refs.coverUploader.click();
            },
            onCoverChanged(event){
                if ( event.target.files[0] ) {
                    this.step1Data.cover = event.target.files[0];
                    this.generatePreview();
                }
            },
            generatePreview(){
                let reader = new FileReader();
                reader.addEventListener('load', ()=>{
                    this.$refs.previewStepImage.src = reader.result;
                });

                reader.readAsDataURL(this.step1Data.cover);
            },
            onCancel(){
                this.resetStepData();
                this.$emit('onCancel');
            },
            onNextStep(){
                this.$emit('onNextStep', this.step1Data);
            },
            resetStepData(){
                this.step1Data = {
                    name: '',
                    description: '',
                    cover: null,
                    level: 'intermedio'
                }
            }
        }
    }
</script>
<style>
    .preview-container {
        background-color: #E0E2FF4D;
    }

    .bg-gray{
        background-color: #E0E2FF4D;
    }

    .preview-img-container{
        background-color: #d9d9d9;
    }

    .preview-img-container i{
        color: #717171;
    }

    .badge-secondary{
        background-color: #b8e4f1;
        color: #180451;
        font-size: 17px;
        font-weight: 500;
        margin: 10px 0;
        border-radius: 10px;
    }

    .preview-card{
        overflow: hidden;
    }

    .preview-card-body{
        padding-bottom: 100px;
    }

    .bg-outline-utel{
        color: #4000BC !important;
        border-color: #4000BC;
        width: auto;
        margin-left: auto;
    }

    .custombutton:disabled{
        background-color: #BCB7D1 !important;
        color: #6B6876 !important;
        border: none !important;
    }

    .step-title{
        color: #1A0054;
        font-weight: 700;
        font-size: 24px;
    }
</style>
